// Hooks
import { useGroupsList } from './useGroupsList';
import { useGroupOperations } from './useGroupOperations';
import { useMasterGroupOperations } from './useMasterGroupOperations';

// Types
import type { UseGroupsReturn } from './types';

const useGroups = (): UseGroupsReturn => {
  const {
    groups,
    setGroups,
    isSaveToGroup,
    setIsSaveToGroup,
    isLoadingList,
    loadingRef,
  } = useGroupsList();

  const { onAddToGroup, onAddToGroups, onCreateGroup, onUpdateAuthInGroups } =
    useGroupOperations({
      groups,
      setGroups,
      setIsSaveToGroup,
    });

  const { onSaveInfluencerToMasterGroup, onSaveInfluencersToMasterGroup } =
    useMasterGroupOperations({
      groups,
      setGroups,
      loadingRef,
    });

  return {
    onAddToGroup,
    groups,
    isSaveToGroup,
    onSaveInfluencerToMasterGroup,
    onSaveInfluencersToMasterGroup,
    onCreateGroup,
    onAddToGroups,
    isLoadingList,
    onUpdateAuthInGroups,
  };
};

export default useGroups;

// Export types for external use
export type { UseGroupsReturn, AuthInput } from './types';
